@if (initialized && dto) {
    @if (uiMode == 'side') {
        <bm-creditor-camt-import-config-side
                [objectIdentifier]="objectIdentifier"
                [dto]="dto"
                [uiMode]="uiMode"
                (onNavigationItems)="handleNavigationItems($event)"
        ></bm-creditor-camt-import-config-side>
    } @else {
        <bm-creditor-camt-import-config-full
                [objectIdentifier]="objectIdentifier"
                [dto]="dto"
                [uiMode]="uiMode"
                (onNavigationItems)="handleNavigationItems($event)"
        ></bm-creditor-camt-import-config-full>
    }
}
